module.exports = __webpack_public_path__ + "img/AdobeStock_195050014.faf69166.jpeg";